import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PushNotificationInputType } from '@/gql/graphql';

export const sendPushNotificationOnLiveCall = async (payload: PushNotificationInputType) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      payload,
    },
    query: graphql(`
      query SendPushNotificationOnLiveCall($payload: PushNotificationInputType) {
        sendPushNotificationOnLiveCall(payload: $payload)
      }
    `),
  });

  return response.data.sendPushNotificationOnLiveCall ?? false;
};
